import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    companyList: [],
    companyListCount: null,
    companyFilter: {
        main_filter: null,
        fields: {
            companyNumber: null,
            companyTitle: null,
            companyClient: null,
            companyType: null,
            companyStatus: null,
            companyCreatedAt: null,
        },
    },
    companyModalOpen: false,
    company_id: null,
    company_index: null,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
